import React, { useContext, useRef } from 'react';
import {IProps, IState} from './types';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import C from '@assets/themes/colors';
import * as S from './styles';
import AddColorIcon from '@assets/icons/addColorIcon';
import Button from '@components/Button';
import Item from '../Item';
import Swipeable from '@components/Swipeable';
import AddColor from '../AddElement/AddColor';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const Section:React.FC<IProps> = (props) => {
  const brandsContext = useContext(BrandsContext);

  const handleUploadItem = () => {
    brandsContext.setBrandAction({section: props.section, action: "add", element: "new"});
  }
  
  let itemsActive =props.items?.filter((item: any) => (item.status === 'ACTIVE')).sort(function(a: any,b: any){
    let lastActionA: any=a.actions[a.actions.length-1];
    let lastActionB: any=b.actions[b.actions.length-1];
    return lastActionB && lastActionA &&  new Date(lastActionB.date).valueOf() - new Date(lastActionA.date).valueOf();
  });
  
  const handleViewAll = () => {
    let sectionTitle = (props?.section.substr(props.section.length - 1) === "s" && props.section.toLowerCase()!=="fonts"  && props.section.toLowerCase()!=="colors")  ? props.section.slice(0, -1) : props?.section;
    sectionTitle = sectionTitle.charAt(0).toUpperCase() + sectionTitle.slice(1);
    brandsContext.setViewAll({open: true, section: props.section, 
      pageTitle: `${brandsContext?.brandDetail?.brand?.name} Brand Library - ${sectionTitle} ${(props.type==="font" || props.type==="color")?"":"Images"}`})
  }

  return (
    <S.Root height={props.type==="img" ? 235 : props.type==="font" ? 180 : 185}>
      {itemsActive?.length>0 && <S.ViewAll onClick={() => handleViewAll()}>VIEW ALL</S.ViewAll>}
      <S.SectionName>{props.sectionName}</S.SectionName>
      <S.Container>
        { props.type==="img" &&
        <Button icon="add" label=""
          style={{hoverBackgroundColor: C.GRAY, backgroundColor: C.WHITE, minWidth: 110, height: 96, borderRadius: '5px', border: 'solid 1px #ccc', margin: '13px 20px 0px 0px', boxSizing: "border-box"}}
          iconStyle={{fillColor: "#AAA6A6", width: 22, height: 22}}
          onClick={handleUploadItem}
        />}

        { props.type==="font" &&
        <Button icon="add" label="FONT"
          style={{hoverBackgroundColor: C.BLUE, backgroundColor: "#19325d", width: 156, height: 16, borderRadius: '5px',  marginRight: '14px', padding: "none"}}
          iconStyle={{fillColor: C.WHITE, width: 15, height: 15}}
          onClick={handleUploadItem}
        />}

        { props.type==="color" && <S.AddColor onClick={handleUploadItem}><AddColorIcon/></S.AddColor>}

        {itemsActive?.length > 0 &&
          <S.SwipeableContainer>
            <Swipeable
              itemsLength={itemsActive.length}
              itemWidth={props.type === "font" ? 240 : 193}
              topArrows={props.type === "color" || props.type === "font" ? 15 : 42}
              id={props.section}
            >
              <TransitionGroup className="group-list">
                { itemsActive.map((item: any, index: number) => {
                    return (
                      <CSSTransition key={item.id} timeout={600} classNames="item">
                        <Item type={props.type} item={item} index={index} section={props.section}/>
                      </CSSTransition>
                    )
                  })
                }
              </TransitionGroup>
            </Swipeable>
          </S.SwipeableContainer>
        }
      </S.Container>
      { (brandsContext.brandAction?.action === "add" && brandsContext.brandAction?.section === "colors" && props.type==="color") && <AddColor/>}
    </S.Root>
  );
}

export default Section;